import { useQuery } from '@tanstack/react-query'
import { fetchOnlineOrderKpis, type OnlineOrderKpis } from '../lib/supabaseQueries'

// Shared online-order KPI query. One cache entry per tenant feeds the list KPI
// row, the Sell-tab badge and the sidebar Trading-tile badge, so the app-wide
// "unattended" count costs a single poll. Gate with `enabled` for users who
// can't see online orders.
export function useOnlineOrderKpis(tid: string, enabled = true) {
  return useQuery<OnlineOrderKpis>({
    queryKey: ['online-order-kpis', tid],
    enabled: !!tid && enabled,
    staleTime: 60 * 1000,
    refetchInterval: 60 * 1000,
    refetchOnWindowFocus: true,
    queryFn: () => fetchOnlineOrderKpis(tid),
  })
}
